import { useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

const ReserveModel = () => {
    const dispatch = useDispatch();
        
    const cancelHandler = () => dispatch(resetModel());

    const confirmation = () => {
        cancelHandler();
    };

    return (
        <Modal className='reserve-model' show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="message-container">
                    <h2>預約完成</h2>
                    <div>
                        <span>感謝您的預約</span>
                    </div>
                    <p>我們已收到您的預約資訊</p>
                    <div>
                        <span>您也可以透過APP</span>
                    </div>
                    <p>查看預約紀錄(需綁定)</p>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ confirmation }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ReserveModel;